import { unwrap, unwrapVoid } from '../http.js';
import { paginate } from '../pagination.js';
export function createUsersApi(client) {
    async function search(query) {
        return unwrap(await client.GET('/v1/users', { params: { query } }));
    }
    return {
        search(q, options) {
            return search({ ...options, q });
        },
        iterateSearch(q, options) {
            return paginate(search, { ...options, q });
        },
        async profile(handle) {
            return unwrap(await client.GET('/v1/users/{handle}', { params: { path: { handle } } }));
        },
        async routines(handle, query) {
            return unwrap(await client.GET('/v1/users/{handle}/routines', {
                params: { path: { handle }, query: query ?? {} },
            }));
        },
        async recipes(handle, query) {
            return unwrap(await client.GET('/v1/users/{handle}/recipes', {
                params: { path: { handle }, query: query ?? {} },
            }));
        },
        async posts(handle, query) {
            return unwrap(await client.GET('/v1/users/{handle}/posts', {
                params: { path: { handle }, query: query ?? {} },
            }));
        },
        async follow(handle) {
            return unwrap(await client.POST('/v1/users/{handle}/follow', { params: { path: { handle } } }));
        },
        async unfollow(handle) {
            return unwrap(await client.DELETE('/v1/users/{handle}/follow', { params: { path: { handle } } }));
        },
        async followers(handle, query) {
            return unwrap(await client.GET('/v1/users/{handle}/followers', {
                params: { path: { handle }, query: query ?? {} },
            }));
        },
        async following(handle, query) {
            return unwrap(await client.GET('/v1/users/{handle}/following', {
                params: { path: { handle }, query: query ?? {} },
            }));
        },
        async block(handle) {
            unwrapVoid(await client.POST('/v1/users/{handle}/block', { params: { path: { handle } } }));
        },
        async unblock(handle) {
            unwrapVoid(await client.DELETE('/v1/users/{handle}/block', { params: { path: { handle } } }));
        },
        async myBlocks(query) {
            return unwrap(await client.GET('/v1/me/blocks', { params: { query: query ?? {} } }));
        },
    };
}
//# sourceMappingURL=users.js.map